import React, { useEffect, useState } from "react";
import { logo } from "../../assets/index";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [show, setShow] = useState(false);

  const transitionNavbar = () => {
    if (window.scrollY > 100) {
      setShow(true);
    } else {
      setShow(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", transitionNavbar);
    return () => window.removeEventListener("scroll", transitionNavbar);
  }, []);

  return (
    <nav
      className={`flex items-center justify-evenly flex-wrap top-0 bg-white fixed w-full z-50 transition pt-2 pb-2 ease-in ${
        show && "bg-[#fff] dark:bg-[#27272E]"
      }`}
    >
      <div className="flex items-center flex-shrink-0 text-[rgb(82, 82, 96)] mr-6 lg:mr-72">
        <img src={logo} className="w-50 h-20 mr-2" alt="Logo" />
        <h2 className="text-2xl dark:text-slate-100">Chabbikar</h2>
      </div>
      <div className="block lg:hidden">
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="flex items-center px-3 py-2 rounded text-black-500 hover:text-black-400"
        >
          <svg
            className={`fill-current h-6 w-6 ${isOpen ? "hidden" : "block"}`}
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" />
          </svg>
          <svg
            className={`fill-current h-6 w-6 ${isOpen ? "block" : "hidden"}`}
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M10 8.586L2.929 1.515 1.515 2.929 8.586 10l-7.071 7.071 1.414 1.414L10 11.414l7.071 7.071 1.414-1.414L11.414 10l7.071-7.071-1.414-1.414L10 8.586z" />
          </svg>
        </button>
      </div>
      <div
        className={`w-full block lg:flex lg:items-center lg:w-auto ${
          isOpen ? "block" : "hidden"
        }`}
      >
        <div
          className={`text-2xl p-4 flex dark:text-white ${
            isOpen && "flex-col"
          } font-medium text-[rgb(82, 82, 96)]`}
        >
          <a
            href="/"
            className="hidden hover:underline md:inline-flex text-white-200 mr-8 text-[20px] hover:text-[#5956e9] duration-200"
          >
            Home
          </a>
          <a
            href="/"
            className="hidden hover:underline md:inline-flex text-white-200 mr-8 text-[20px] hover:text-[#5956e9] duration-200"
          >
            About
          </a>
          <a
            href="/"
            className="hidden hover:underline md:inline-flex text-white-200 mr-8 text-[20px] hover:text-[#5956e9] duration-200"
          >
            Skills
          </a>
          <a
            href="/"
            className="hidden hover:underline md:inline-flex text-white-200 mr-8 text-[20px] hover:text-[#5956e9] duration-200"
          >
            Contact
          </a>
        </div>
      </div>
    </nav>
  );
};
export default Navbar;
